import { AxiosResponse } from 'axios';
import { apiClient } from '../instance';
import { CreatePriceListRequest, PriceList } from '../../types/interfaces';

export const pricesApi = {
  fetchPrices: (): Promise<AxiosResponse<PriceList[]>> => {
    return apiClient.get('/pricelists/');
  },
  fetchPriceById: (id: number): Promise<AxiosResponse<PriceList>> => {
    return apiClient.get(`/pricelists/${id}/`);
  },
  createPrice: (formData: FormData): Promise<AxiosResponse<PriceList>> => {
    return apiClient.post('/pricelists/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  // Метод изменён с PUT на PATCH: при редактировании прайса
  // фронт никогда не присылает «весь объект» — только то, что
  // юзер реально поменял (файл может быть пустым, если пользователь
  // его не перезагружал). PUT с required `file` на серверной модели
  // (Pricelist.file = FileField без null=True/blank=True) валился
  // 400'ой «This field is required.». PATCH в DRF — partial=True,
  // и недостающие поля не считаются ошибкой, а оставляются как есть.
  updatePrice: (id: number, data: FormData): Promise<AxiosResponse<PriceList>> => {
    return apiClient.patch(`/pricelists/${id}/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  patchPrice: (id: number, data: Partial<FormData>): Promise<AxiosResponse<PriceList>> => {
    return apiClient.patch(`/pricelists/${id}/`, data);
  },
  deletePrice: (id: number): Promise<AxiosResponse<void>> => {
    return apiClient.delete(`/pricelists/${id}/`);
  },
};
